import { inject } from 'vue';
export default {
  props: {
    title: String,
    description: String,
    button_1: String,
    button_2: String,
    imgUrl: String
  },
  setup() {
    const {
      historyOrder
    } = inject("cart");
    return {
      historyOrder
    };
  }
};